import React from 'react';
import StatusBadges from './StatusBadges';
import OrderButton from './OrderButton';
import ProposalButtons from './ProposalButtons';
import PlayButton from './PlayButton';

const ActionButton = ({ order, version, organization, organizationContent }) => {
    if (!order) return null;

    const { statusWorkflow, orderType } = order;

    // Request declined
    if (statusWorkflow === 'request-declined') {
        return <StatusBadges statusWorkflow={statusWorkflow} />;
    }

    // Coming soon
    if (['to-order', 'request'].includes(orderType) && statusWorkflow === 'coming-soon') {
        return <StatusBadges statusWorkflow={statusWorkflow} />;
    }

    // Ready to play - show play button
    if (orderType === 'order' && ['ready-on-mediablock', 'finished-playback'].includes(statusWorkflow)) {
        return (
            <PlayButton
                order={order}
                label="PLAY MOVIE"
                organization={organization}
                organizationContent={organizationContent}
            />
        );
    }

    // Request accepted - show accept/decline buttons
    if (orderType === 'request' && statusWorkflow === 'request-accepted') {
        return <ProposalButtons order={order} />;
    }

    // Delivery pending
    if (orderType === 'order' && order.purchasedAt &&
        ['ready-to-play', 'movie-delivery-pending', 'key-delivery-pending'].includes(statusWorkflow)) {
        return <StatusBadges statusWorkflow={statusWorkflow} />;
    }

    // Default: Order/Request button
    if (['to-order', 'request'].includes(orderType) &&
        statusWorkflow !== 'request-accepted' &&
        statusWorkflow !== 'request-pending') {
        return <OrderButton order={order} version={version} />;
    }

    return null;
};

export default ActionButton;
